import { ADD_LOGIN_DATA, REMOVE_ITEM ,RESET_LOGIN_DATA} from './actionTypes';

const initialState = {
  items: [],
  loginData:{
    id:"",
    username:"",
    authToken:"",
    otpToken:"",
    verifyOtpToken:"",
    name:"",
    role:""
  }
};

const itemReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LOGIN_DATA:
      return {
        ...state,
        loginData: {...state.loginData, ...action.payload},
      };
    case REMOVE_ITEM:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };
      case RESET_LOGIN_DATA:
        return {
          ...state,
          loginData: initialState.loginData // Reset loginData to initial state
        };
    default:
      return state;
  }
};

export default itemReducer;
